module.exports = __webpack_public_path__ + "img/logo-lg.png";